<main>
  <!-- Hero Section -->
  <section
    class="bg-[url('/assets/images/ModelX_75.webp')] bg-cover bg-center bg-blend-multiply bg-black/50 min-h-[40vh] flex flex-col justify-center items-center text-white px-3 md:px-5 2xl:px-28 3xl:px-52"
  >
    <div
      class="container flex flex-col justify-center items-center text-center"
    >
      <h1 class="text-3xl lg:text-5xl font-extrabold text-center mb-3">
        Terms and Conditions
      </h1>
      <p class="text-white font-semibold text-center text-lg lg:text-xl">
        Understanding Your Rights and Responsibilities
      </p>
    </div>
  </section>

  <section class="px-3 md:px-5 2xl:px-28 3xl:px-52 py-10 xl:py-16 w-full flex justify-center">
    <div class="container mx-auto">
      <out-terms></out-terms>
    </div>
  </section>
</main>
